'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002422 from "./presto.-Two-Factor-Auth-View$$anon$22.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002424 from "./presto.-Two-Factor-Auth-View$$anon$24.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002426 from "./presto.-Two-Factor-Auth-View$$anon$26.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002428 from "./presto.-Two-Factor-Auth-View$$anon$28.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$21() {
  this.bAI = null;
  this.bAA = null;
  this.bAB = false;
  this.bAJ = null;
  this.bAK = false;
  this.bAN = null;
  this.bAG = null;
  this.bAH = false;
  this.bAC = null;
  this.bAD = false;
  this.bAE = null;
  this.bAF = false;
  this.bAL = false;
  this.bAM = false;
  this.bAI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bAN = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$21 as $c_Lpresto_TwoFactorAuthView$$anon$21 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$21;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$21() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$21 as $h_Lpresto_TwoFactorAuthView$$anon$21 };
$h_Lpresto_TwoFactorAuthView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bAI;
});
$p.L = (function() {
  if ((!this.bAB)) {
    this.bAA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bAB = true;
  }
  return this.bAA;
});
$p.O = (function() {
  if ((!this.bAK)) {
    this.bAJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bAK = true;
  }
  return this.bAJ;
});
$p.E = (function() {
  return this.bAN;
});
$p.t = (function() {
  if ((!this.bAH)) {
    this.bAG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bAH = true;
  }
  return this.bAG;
});
$p.M = (function() {
  if ((!this.bAD)) {
    this.bAC = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002422.$c_Lpresto_TwoFactorAuthView$$anon$22(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002424.$c_Lpresto_TwoFactorAuthView$$anon$24())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002426.$c_Lpresto_TwoFactorAuthView$$anon$26())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bAD = true;
  }
  return this.bAC;
});
$p.Q = (function() {
  if ((!this.bAF)) {
    this.bAE = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002428.$c_Lpresto_TwoFactorAuthView$$anon$28();
    this.bAF = true;
  }
  return this.bAE;
});
$p.w = (function() {
  if ((!this.bAM)) {
    this.bAL = false;
    this.bAM = true;
  }
  return this.bAL;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee205) => ((p) => \u03b4scrutinee205.z5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$21, "presto.TwoFactorAuthView$$anon$21", ({
  Si: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$21 as $d_Lpresto_TwoFactorAuthView$$anon$21 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$21.js.map
